import Hotjar from '@hotjar/browser';
import Analytics from 'analytics'
import googleTagManager from '@analytics/google-tag-manager'

export const analytics = Analytics({
  app: 'finhudas.app',
  plugins: [
    googleTagManager({ containerId: 'GTM-PXVJPBF4' })
  ]
})

if (window.location.host !== 'localhost:5173') {
  Hotjar.init(5201345, 6);
  analytics.page()
}
